import { CancelButton, SaveButton } from '@core/components/Buttons';
import { FormDialogContent, SimpleDialog } from '@core/components/Dialog';
import { TextInput } from '@core/components/Inputs';
import { SelectInput } from '@core/components/Select';
import { mensagemCampoObrigatorio, mensagemMinimoXCaracteres } from '@core/util/mensagemUtil';
import { Grid } from '@material-ui/core';
import { cancelarAlert } from 'app/services/alerts';
import { eventReactGA } from 'app/utils/analyticsUtil';
import { FormikProvider, useFormik } from 'formik';
import React, { useContext } from 'react';
import { FaUsers } from 'react-icons/fa';
import * as Yup from 'yup';
import { CategoriaContext } from '../../CategoriaContext';
import DreList from '../DreList';

const title = {
  receita: 'Adicionar receita',
  despesa: 'Adicionar despesa',
};

const CategoriaDialog = ({ onAdd }) => {
  const [dialogOpen, setDialogOpen] = useContext(CategoriaContext).dialogOpen;
  const [dreReceitaList] = useContext(CategoriaContext).dreReceitaList;
  const [dreDespesaList] = useContext(CategoriaContext).dreDespesaList;

  const [classesReceita] = useContext(CategoriaContext).classesReceita;
  const [classesDespesa] = useContext(CategoriaContext).classesDespesa;

  const [classesAnaliticoSintetico] = useContext(CategoriaContext).classesAnaliticoSintetico;
  const [planoContasId] = useContext(CategoriaContext).planoContasId;

  const classesSinteticas =
    dialogOpen === 'receita'
      ? classesAnaliticoSintetico.receita.sintetico
      : classesAnaliticoSintetico.despesa.sintetico;

  const classeSchema = Yup.object().shape({
    nome: Yup.string()
      .nullable()
      .min(3, mensagemMinimoXCaracteres(3))
      .required(mensagemCampoObrigatorio('a descrição.')),
    dre: Yup.string().nullable(),
    classePaiId: Yup.string()
      .required(mensagemCampoObrigatorio('a classe de origem'))
      .nullable(),
  });

  const initialValues = {
    nome: '',
    dre: '',
    classePaiId: '-',
  };

  const handleCloseModal = () => {
    const close = () => {
      formik.resetForm(initialValues);
      setDialogOpen(false);
    };

    if (formik.dirty) {
      cancelarAlert({
        confirmar: close,
      });
    } else {
      close();
    }
  };

  const handleSubmit = async (data) => {
    const _classe = {
      nome: data.nome,
      dreId: data.dre,
      classePaiId: data.classePaiId === '-' ? null : data.classePaiId,
      natureza: dialogOpen.toUpperCase(),
      planoContasId,
    };

    if (dialogOpen === 'receita') {
      eventReactGA('Categoria', 'Adicionar categoria de receita');
    } else {
      eventReactGA('Categoria', 'Adicionar categoria de despesa');
    }

    const novaClasse = await onAdd(_classe, classesReceita, classesDespesa);

    if (novaClasse) {
      formik.resetForm(initialValues);
      setDialogOpen(false);
    }
  };

  const formik = useFormik({
    validationSchema: classeSchema,
    initialValues,
    onSubmit: handleSubmit,
  });

  const FormCategoria = () => {
    return (
      <div className="p-16">
        <Grid container spacing={3}>
          <Grid item xs={12} sm={12} md={12} xl={12} lg={12}>
            <TextInput
              id="nome"
              name="nome"
              onChange={formik.handleChange}
              value={formik.values.nome}
              error={formik.errors.nome}
              touched={!!formik.errors.nome}
              helperText={formik.errors.nome}
              required
              autoFocus
              fullWidth
              variant="outlined"
              label="Descrição"
              maxLength={128}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={12} xl={12} lg={12}>
            <SelectInput
              label="Incluir dentro de"
              id="classePaiId"
              name="classePaiId"
              value={formik.values.classePaiId}
              error={formik.errors.classePaiId}
              touched={!!formik.errors.classePaiId}
              helperText={formik.errors.classePaiId}
              onChange={formik.handleChange}
              options={classesSinteticas
                .filter((classe) => !!classe)
                .map((classe) => ({
                  id: classe.id,
                  title: `${classe.indice} ${classe.nome}`,
                }))}
              required
            />
          </Grid>
          <Grid item xs={12} sm={12} md={12} xl={12} lg={12}>
            <DreList
              name="dre"
              id="dre"
              selecionado={formik.values.dre}
              onChange={formik.handleChange}
              dres={dialogOpen === 'receita' ? dreReceitaList : dreDespesaList}
            />
          </Grid>
        </Grid>
      </div>
    );
  };

  return (
    <SimpleDialog open={dialogOpen} onClose={handleCloseModal}>
      <FormikProvider value={formik}>
        <FormDialogContent
          onSubmit={formik.handleSubmit}
          header={{
            title: title[dialogOpen],
            icon: <FaUsers />,
            toolbar: (
              <>
                <CancelButton onClick={handleCloseModal}>Cancelar</CancelButton>
                <SaveButton id="add-classe-root" type="submit">
                  Adicionar
                </SaveButton>
              </>
            ),
          }}
          contentStyle={{ padding: 0 }}
          content={<FormCategoria />}
        />
      </FormikProvider>
    </SimpleDialog>
  );
};

const areEqual = (prev, next) => {
  return prev.open === next.open;
};

export default React.memo(CategoriaDialog, areEqual);
